export enum EscrowVerificationTypes {
  ItemVerification = 'item_verification',
  ElectronicsVerification = 'electronics_verification',
}

export enum DeductionActionTypes {
  SalesTax = 'sales_tax',
  BuyerProtectionFee = 'buyer_protection_fee',
}

export enum OrderSummaryActionType {
  SalesTax = 'sales_tax',
  BuyerProtectionFee = 'buyer_protection_fee',
  EscrowConversion = 'escrow_conversion',
  ReturnLabelConversion = 'return_label_conversion',
}

export enum OrderSummaryItemNoteType {
  Verify = 'verify',
  Submit = 'submit',
}

export enum OrderSummaryActionSalesTaxType {
  ExtraService = 'extra_services',
  Escrow = 'escrow',
}

export enum OrderSummaryEscrowCurrencyConversionShippingType {
  Custom = 'custom',
  Integrated = 'integrated',
}

export enum InfoBannerType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum ItemDisposalConditions {
  None = 0,
  ForSell = 4,
}

export enum ExtraServiceOrderType {
  PushUp = 'push_up_order',
  ClosetPromotion = 'closet_promotion_order',
  DirectDonation = 'direct_donation_order',
  ReturnLabel = 'return_label_order',
  Transaction = 'transaction',
}

export enum CheckoutOrderType {
  PushUp = 'push_up',
  ClosetPromotion = 'closet_promotion',
  DirectDonation = 'direct_donation',
  ReturnLabel = 'return_label',
  Transaction = 'transaction',
}

export const CheckoutOrderTypeMap = {
  [ExtraServiceOrderType.PushUp]: CheckoutOrderType.PushUp,
  [ExtraServiceOrderType.ClosetPromotion]: CheckoutOrderType.ClosetPromotion,
  [ExtraServiceOrderType.DirectDonation]: CheckoutOrderType.DirectDonation,
  [ExtraServiceOrderType.ReturnLabel]: CheckoutOrderType.ReturnLabel,
  [ExtraServiceOrderType.Transaction]: CheckoutOrderType.Transaction,
}
